import React, { useCallback, useEffect, useState } from 'react';
import { ClientJS } from 'clientjs';
import { isMobileDevice, getDeviceInfo, redirectToUrl } from '../utils/common';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { parseURL } from '../utils/convertParams';
import * as AppActions from '../stores/app/actions';
import { useNavigate } from 'react-router-dom';
import { Modal } from '../components/modal/index.jsx';
import ErrorIcon from '../assets/error-icon.svg';
import { Footer } from 'react-components-core';
import styled from '@emotion/styled';
import {
    STATUS_PROCESS_OBV,
    STATUS_PROGRESS_LOADING
} from '../constants/status.js';
import LoadingProgress from '../components/loading/index.jsx';
import { DepositWrapperStyled } from '../components/deposit/styled.jsx';
import { useMappingErrorMessage } from '../hooks/useMappingErrorMessage.js';
import { getTransactionInfo } from '../utils/sessionStorage.js';
import { useTranslation } from 'react-i18next';

export const BodyBankSelectionStyled = styled.div`
 height: calc(100vh - 65px);
`;
const hideBodyBank = { overflow: 'hidden', height: 0 };

const OAuthCallback = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { params } = parseURL(window.location.href);

    // Create loading messages array from i18n
    const loadingMessages = [
        t('loading.message.processing'),
        t('loading.message.verifying')
    ];

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [statusProgress, setStatusProgress] = useState(STATUS_PROGRESS_LOADING.START);
    const [activeLoading, setActiveLoading] = useState(false);
    const error = useMappingErrorMessage();

    const isMobile = isMobileDevice();

    const appStore = useSelector((state) => state, shallowEqual).app;

    const obvInfo = getTransactionInfo();
    
    const { isLoading, statusProcess } = appStore;
    const { oauth_state_id, receivedRedirectUri } = params;

    useEffect(() => {
        const deviceInfo = getDeviceInfo(new ClientJS());
        dispatch(AppActions.continueOAuthCallback(deviceInfo, receivedRedirectUri));
    }, [dispatch, oauth_state_id, receivedRedirectUri])

    useEffect(() => {
        if (error?.message) {
            setIsModalVisible(true);
            setActiveLoading(false);
        }
    }, [error]);

    useEffect(() => {
        if (isLoading) {
            setActiveLoading(true);
            setStatusProgress(STATUS_PROGRESS_LOADING.START);
        } else {
            setStatusProgress(STATUS_PROGRESS_LOADING.FINISH);
        }
        return () => {
            setStatusProgress(STATUS_PROGRESS_LOADING.NONE);
        };
    }, [isLoading]);

    useEffect(() => {
        if (statusProcess === STATUS_PROCESS_OBV.CONTINUE_OAUTH_CALLBACK_SUCCESS) {
            if (obvInfo?.app2appEnabled && obvInfo?.merchantReturnUrl) {
                //The merchant has enabled App2App. Redirecting the user to AppReturnUrl to avoid reinitializing the Plaid link token in this session
                redirectToUrl(obvInfo?.merchantReturnUrl);
                return;
            }
            navigate(`/bank-select?${new URLSearchParams({ oauth_state_id }).toString()}`);
        }
    }, [statusProcess, oauth_state_id, navigate, obvInfo])

    const showingCancel = useCallback(() => {
        navigate(`/safe-to-close?${new URLSearchParams({ isSuccess: false, isCancel: true }).toString()}`);
    }, [navigate])

    return (
        <div className='VerifyBank'>
            <BodyBankSelectionStyled style={isMobile ? hideBodyBank : {}}>
                <DepositWrapperStyled customStyle={{ isMobile }}>
                    <div className='box-extend'>
                        <Modal
                            message={error?.message}
                            subMessage={error?.subMessage}
                            description={error?.description}
                            errorUrl={ErrorIcon}
                            isFullScreen={true}
                            visible={isModalVisible}
                            buttonLabel={'Cancel'}
                            onClickBack={showingCancel}
                        />
                        <LoadingProgress
                            active={activeLoading}
                            messages={loadingMessages}
                            timeNextMessage={3000}
                            timeBackgroundRun={2000}
                            progress={statusProgress}
                            afterFinish={() => {
                                setActiveLoading(false);
                                setStatusProgress(STATUS_PROGRESS_LOADING.NONE);
                            }}
                        />
                    </div>
                </DepositWrapperStyled>
            </BodyBankSelectionStyled>
            {!error && <Footer integration='plaidNuvei'></Footer>}
        </div>
    )
}

export default OAuthCallback;